import { Injectable, signal } from '@angular/core';
import { IPagination } from '../../../../core/interfaces/IPagination';
import { OnlineOrderStatuses } from '../enums/OnlineOrderStatuses';
import { IOnlineOrder } from '../interfaces/IOnlineOrder';

@Injectable()
export class OnlineOrdersStore {

  public readonly orders = signal<IOnlineOrder[]>([]);
  public readonly status = signal<OnlineOrderStatuses>(OnlineOrderStatuses.Open);
  public readonly search = signal('');
  public readonly pagination = signal<IPagination>({ page: 1, results: 10, totalResults: 0 });
  public readonly isLoading = signal(false);
}
